/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var $:any;
@Component({
  templateUrl:'./versionEdit.html'
})

export class VersionEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location,
    private common:CommonService,
    private fileupload:FileUpload
  ){}

  private data:any={
    "isForce": "",
    "os": "",
    "url": "",
    "verson": ""
  }

  private isCreate:boolean=false;
  private os
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.os=params['id'];
      this.getData();
    });
  }





  private getData():void{
    this.HttpService.getData(API.systemSetting_version_detail,{'os':this.os}).then(res=>{
      this.data = res.data;

    })
  }



  private submit():void{
    this.HttpService.postData(API.systemSetting_version_update,{
      "isForce": this.data.isForce,
      "os": this.data.os,
      "url":this.data.url,
      "verson": this.data.verson
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }


}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/systemSetting/versionEdit.component.ts